export const allergenOptions = [
  "Wheat",
  "Barley",
  "Rye",
  "Oats",
  "Spelt",
  "Gluten",
  "Milk",
  "Egg",
  "Nuts",
  "Soy",
  "Fish",
  "Crustacean",
  "Sulphite",
]

export const ML_global_allergens_options = [
  { key: "Wheat", value: "Wheat (Gluten)" },
  { key: "Barley", value: "Barley (Gluten)" },
  { key: "Oats", value: "Oats (Gluten)" },
  { key: "Rye", value: "Rye (Gluten)" },
  { key: "Spelt", value: "Spelt (Gluten)" },
  {
    key: "Crustacean",
    value: "Crustacean",
    showListOnClick: true,
    additional: [
      { key: "Lobster", value: "Lobster" },
      { key: "Shrimp", value: "Shrimp" },
      { key: "Crab", value: "Crab" },
      { key: "Crayfish", value: "Crayfish" },
      { key: "Prawn", value: "Prawn" },
      { key: "Krill", value: "Krill" },
    ],
  },
  { key: "Egg", value: "Egg" },
  {
    key: "Fish",
    value: "Fish",
    showListOnClick: true,
    additional: [
      { key: "Haddock", value: "Haddock" },
      { key: "Cod", value: "Cod" },
      { key: "Tilapia", value: "Tilapia" },
      { key: "Tuna", value: "Tuna" },
      { key: "Salmon", value: "Salmon" },
      { key: "Perch", value: "Perch" },
      { key: "Flounder", value: "Flounder" },
    ],
  },
  { key: "Soy", value: "Soy" },
  { key: "Milk", value: "Milk" },
  { key: "Sulphite", value: "Sulphite" },
  { key: "Nuts", value: "Nuts (Peanut)" },
  {
    key: "Tree Nuts",
    value: "Tree Nuts",
    showListOnClick: true,
    additional: [
      { key: "Almond", value: "Almond" },
      { key: "Beech Nut", value: "Beech Nut" },
      { key: "Brazil Nut", value: "Brazil Nut" },
      { key: "Butternut", value: "Butternut" },
      { key: "California Nut", value: "California Nut" },
      { key: "Cashew", value: "Cashew" },
      { key: "Chestnut", value: "Chestnut" },
      { key: "Chinquapin", value: "Chinquapin" },
      { key: "Coconut", value: "Coconut" },
      { key: "Kola Nut", value: "Kola Nut" },
      { key: "Hazelnut", value: "Hazelnut" },
      { key: "Ginkgo Nut", value: "Ginkgo Nut" },
      { key: "Heartnut", value: "Heartnut" },
      { key: "Hickory Nut", value: "Hickory Nut" },
      { key: "Macadamia Nut", value: "Macadamia Nut" },
      { key: "Palm Nut", value: "Palm Nut" },
      { key: "Pecan", value: "Pecan" },
      { key: "Pine Nut", value: "Pine Nut" },
      { key: "Pili Nut", value: "Pili Nut" },
      { key: "Pistachio", value: "Pistachio" },
      { key: "Shea Nut", value: "Shea Nut" },
      { key: "Walnut", value: "Walnut" },
    ],
  },
  { key: "Sesame", value: "Sesame" },
  { key: "Celery", value: "Celery" },
  { key: "Mustard", value: "Mustard" },
  {
    key: "Molluscs",
    value: "Molluscs",
    showListOnClick: true,
    additional: [
      { key: "Mussels", value: "Mussels" },
      { key: "Clams", value: "Clams" },
      { key: "Scallops", value: "Scallops" },
      { key: "Squids", value: "Squids" },
      { key: "Land Snails", value: "Land Snails" },
      { key: "Whelks", value: "Whelks" },
    ],
  },
  { key: "Lupin", value: "Lupin" },
]

export const allergenOptionsPfl = [
  "Wheat",
  "Barley",
  "Rye",
  "Oats",
  "Spelt",
  "Gluten",
  "Milk",
  "Egg",
  "Nuts",
  "Soy",
  "Fish",
  "Crustacean",
  "Sulphite",
]
